import { Component, DestroyRef, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureFlags } from '@core/enumeration';
import { InboundFaxActionWrapper } from '@core/model';
import { InboundFaxService, MemberService, TenantService } from '@core/service';
import { PortalProducts } from '@shared/enumeration';
import { FeatureToggleService, ProductNames, TenantNames } from '@mynexus/mynexus-ui-lib';
import { ElementRegistryService } from '@shared/services/element-registry.service';
import { BehaviorSubject, forkJoin } from 'rxjs';

@Component({
    selector: 'dmepos-auth-request-wrapper',
    templateUrl: './authorization-request.component.html',
    standalone: false
})
export class AuthorizationRequestComponent implements OnInit, OnDestroy {
  tenantId: string;
  memberId: string;
  member: unknown;
  inboundFaxData: InboundFaxActionWrapper;
  tab: number;
  authorizationByProductId: string;
  isLoading$ = new BehaviorSubject<boolean>(true);

  private listenerWasAdded = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private memberService: MemberService,
    private elementRegistry : ElementRegistryService,
    private featureToggleService: FeatureToggleService,
    private readonly destroyRef: DestroyRef,
    private tenantService: TenantService,
    private readonly inboundFaxService: InboundFaxService
  ) {
    const { tenantId, memberId, authorizationByProductId } = this.route.snapshot.params;
    this.tenantId = tenantId;
    this.memberId = memberId;
    this.authorizationByProductId = authorizationByProductId;

    const { tab } = this.route.snapshot.queryParams;
    if (tab) this.tab = parseInt(tab);
  }

  ngOnInit(): void {
    if (this.elementRegistry.scriptsHaveBeenLoaded.has('mnc-dmepos')) {
      this.isLoading$.next(false);
    } else {
      // listen event when all mnc-dmepos components are loaded
      document.addEventListener('mnc-dmepos-loaded', () => {
        this.isLoading$.next(false);
      });
      this.listenerWasAdded = true;

      // use it to load mnc-dmepos component instead of lazyComponent in HTML template
      this.elementRegistry.prepare('mnc-dmepos');
    }

    this.memberService.getBySubscriberNumber(this.tenantId, this.memberId).subscribe((data) => (this.member = data));
    this.inboundFaxService.inboundFaxData$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (data?.productName === ProductNames.DMEPOS) {
          this.inboundFaxData = data;
        }
      });
  }

  ngOnDestroy(): void {
    if (this.listenerWasAdded) {
      // END listen custom event 'mnc-dmepos-loaded'
      document.removeAllListeners('mnc-dmepos-loaded');
    }
    this.inboundFaxService.InboundFaxData = null;
  }

  cancelRequest() {
    this.inboundFaxService.InboundFaxData = null;
    this.router.navigate([this.tenantId, 'member', this.memberId]);
  }

  goToHome(): void {
    this.router.navigate(['/home']);
  }

  goToProviderDashboard(): void {
    this.router.navigate([this.tenantId, 'dmepos', 'provider-dashboard']);
  }

  goToAuthorization(event): void {
    this.router.navigate([this.tenantId, PortalProducts.DMEPOS, 'auth-dashboard', event.detail]);
  }
}
